export default "__VITE_ASSET__UOxjPJfeiv2CYz4lfG7uAw__"